import * as tslib_1 from "tslib";
import { Split } from '../split';
var LegendComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LegendComponent, _super);
    function LegendComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LegendComponent;
}(Split));
export { LegendComponent };
//# sourceMappingURL=component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/build/src/compile/legend/component.js
// module id = 942
// module chunks = 0